import defaultTo from 'lodash/fp/defaultTo';
import flow from 'lodash/fp/flow';
import get from 'lodash/fp/get';
import orderBy from 'lodash/fp/orderBy';

export function getOfferingPrice(cmsProduct, offering) {
  return flow(
    get('commitmentReward.price'),
    defaultTo(cmsProduct.price),
    parseFloat
  )(offering);
}

export function sortProductOfferingsByPrice(cmsProduct) {
  return orderBy(offering => getOfferingPrice(cmsProduct, offering), 'asc')(
    cmsProduct.offerings
  );
}
